import React from 'react';
import { CardBody, Card } from 'reactstrap';
import { useTranslator } from '@front-activerse/common-components';
import IngredientReplacement from './CookbookIngredientReplacement';
import { ReplaceIngredientConnectorApollo } from '@front-activerse/common-components';

const CookbookIngredientReplacementList = ({
  isReplaced,
  replacements,
  originalIngredient,
  multiplier,
  dishId,
  ingredientId,
  mealId,
  ingredientKey,
  closeCollapse,
}) => {
  const { t } = useTranslator();

  return (
    <ReplaceIngredientConnectorApollo mealId={mealId}>
      {({ replaceIngredient }) => (
        <Card>
          <CardBody>
            {isReplaced ? (
              <React.Fragment>
                <p className="semi-bold">{t('meal/original-product')}:</p>
                <ul className="ingredients mb-l">
                  <IngredientReplacement
                    key={originalIngredient.id}
                    name={originalIngredient.name}
                    measurements={originalIngredient.measurements}
                    multiplier={multiplier}
                    replaceIngredient={replaceIngredient}
                    originalIngredientId={originalIngredient.id}
                    id={originalIngredient.id}
                    dishId={dishId}
                    ingredientKey={ingredientKey} // needed for cache update
                    closeCollapse={closeCollapse}
                  />
                </ul>
              </React.Fragment>
            ) : (
              ''
            )}

            {replacements.length > 0 ? (
              <React.Fragment>
                <p className="semi-bold replacement-list-title">{t('meal/exchange-for')}:</p>
                <ul className="ingredients">
                  {replacements.map((replacement) => (
                    <IngredientReplacement
                      key={replacement.id}
                      name={replacement.name}
                      measurements={replacement.measurements}
                      multiplier={multiplier}
                      replaceIngredient={replaceIngredient}
                      id={replacement.id}
                      dishId={dishId}
                      originalIngredientId={isReplaced ? originalIngredient.id : ingredientId}
                      ingredientKey={ingredientKey} // needed for cache update
                      closeCollapse={closeCollapse}
                    />
                  ))}
                </ul>
              </React.Fragment>
            ) : (
              ''
            )}
          </CardBody>
        </Card>
      )}
    </ReplaceIngredientConnectorApollo>
  );
};

export default CookbookIngredientReplacementList;
